/**
 * ContentDispositionから日本語ファイル名を取得します。
 * @param disposition ContentDisposition
 * @returns 日本語ファイル名
 */
const getFileNameFromContentDisposition = (disposition: string) => {
  //const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/ // 正規表現でfilenameを抜き出す
  const filenameRegex = /filename[^;=\n]=((['"]).*?\2|[^;\n]*)/
  const matches = filenameRegex.exec(disposition)
  if (matches != null && matches[1]) {
    const fileName = matches[1].replace(/['"]/g, "")
    return decodeURI(fileName).replace("UTF-8", "") // 日本語対応
  } else {
    return null
  }
}

/**
 * blobのダウンロードを提供します。
 * @param {Blob} blob Blobデータ
 * @param {string} fileName ファイル名
 */
const downloadBlob = (blob: Blob, fileName: string | null, contentType: string) => {
  // if (window.navigator.msSaveOrOpenBlob) {
  //   // for IE,Edge
  //   window.navigator.msSaveOrOpenBlob(blob, fileName);
  // } else {
  // for chrome, firefox
  const url = URL.createObjectURL(new Blob([blob], { type: contentType }))
  const linkEl = document.createElement("a")
  linkEl.href = url
  linkEl.setAttribute("download", fileName ?? url)
  document.body.appendChild(linkEl)
  linkEl.click()
  URL.revokeObjectURL(url)
  linkEl.parentNode!.removeChild(linkEl)
  // }
}

const htmlPageUtil = {
  getFileNameFromContentDisposition,
  downloadBlob,
}

export default htmlPageUtil
